/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/3/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';

type Props = {
  name: string,
  aggFormat: Function,
  value: number,
}

const InventoryResultSummary = ({ name, aggFormat, value }: Props) => (
  value !== null
    ? (
      <div>
        {name}: {aggFormat(value)}
      </div>
    )
    : null
);

export default InventoryResultSummary;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryResultSummary/InventoryResultSummary.jsx